//import $ from 'jquery';

export default function OnPageLoaded(closeTopNav, scrollToTheTop) {
    if (closeTopNav){
        let element = document.getElementById("navbarSupportedContent");
        element.classList.remove("show");
        element = document.getElementById("btnnavbartoggler");
        element.classList.add("collapsed");
        element.setAttribute("aria-expanded", "false"); 
        //$('.navbar-collapse').collapse('hide');
    }
    if (scrollToTheTop)
        window.scrollTo(500, 0);
}


// WEBPACK FOOTER //
// ./src/utils/onpageloaded.js